import { adminStaffRoles } from '@anytag/shared-constants';
import { Outlet, redirect } from '@tanstack/react-router';
import { PermissionRoute } from '../../../components';
import { VideoCompAI } from '../../../pages/tools';
import { PartialRouter } from '../../types';

export const ToolsRouter = {
  '/_private-routes/tools': [() => <PermissionRoute permissions={adminStaffRoles} />, {}],
  '/_private-routes/tools/': [
    () => <Outlet />,
    {
      beforeLoad: () => {
        throw redirect({
          to: '/tools/video-comp-ai'
        });
      }
    }
  ],
  '/_private-routes/tools/video-comp-ai': [VideoCompAI, {}]
} as const satisfies PartialRouter;
